<template>
    <component :is="layout">
        <router-view></router-view>
    </component>
</template>

<script>
	import { Layout } from '@/utility/constants'

	export default {
		computed: {
			layout() {
				return `${this.$route.meta.layout || Layout.DEFAULT}-layout`
			}
		}
	}
</script>